module.exports = require('./helpers/bundle-url').getBundleURL('g5qyd') + "logo-dark.eefe0b7f.svg";